import { render, staticRenderFns } from "./VFormGroup.vue?vue&type=template&id=5f6504fe&functional=true&"
import script from "./VFormGroup.vue?vue&type=script&lang=js&"
export * from "./VFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./VFormGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports